<template>
  <div class="header">
    <!-- Top Navigation Bar -->
    <v-app-bar
      class="top-navbar"
      color="transparent"
      dark
      flat
      fixed
      height="80"
      elevate-on-scroll
    >
      <!-- Logo -->
      <v-toolbar-title class="logo-section">
        <router-link to="/">
          <img src="assets/logo.png" class="logo-img" />
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Navigation Menu (Desktop) -->
      <div class="nav-menu d-none d-lg-flex">
        <v-btn style="height: 39px; width: 39px" to="/" icon>
          <v-icon size="24">mdi-home</v-icon>
        </v-btn>
        <!-- <v-btn text class="nav-btn" to="/partners">Partners</v-btn>
        <v-btn text class="nav-btn" to="/exhibit">Exhibit</v-btn>
        <v-btn text class="nav-btn" to="/agenda">Agenda</v-btn>
        <v-btn text class="nav-btn" to="/startup-zone">Startup Zone</v-btn>
        <v-btn text class="nav-btn" to="/media">Media</v-btn>
        <v-btn text class="nav-btn" to="/contact">Contact</v-btn> -->
      </div>

      <!-- Submissions Link (Admin) -->
      <!-- <v-btn
        to="/submissions"
        text
        class="nav-btn"
      >
        Бүртгэлүүд
      </v-btn> -->

      <!-- Book Tickets Button -->
      <gradient-button
        class="ml-1"
        style="background-color: orange"
        variant="bordered"
        size="small"
        to="/form-fill"
      >
        Бүртгүүлэх
      </gradient-button>

      <!-- Mobile Menu Icon -->
      <v-app-bar-nav-icon
        class="d-lg-none ml-2"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" app temporary dark width="280">
      <v-list class="pt-4">
        <v-list-item class="mb-4">
          <v-list-item-content>
            <v-list-item-title class="text-h6 font-weight-bold">
              INTERNATIONAL EDU TRAVEL
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-2"></v-divider>

        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/partners">
          <v-list-item-icon>
            <v-icon>mdi-handshake</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Partners</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/exhibit">
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Exhibit</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/agenda">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Agenda</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/startup-zone">
          <v-list-item-icon>
            <v-icon>mdi-rocket-launch</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Startup Zone</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/media">
          <v-list-item-icon>
            <v-icon>mdi-newspaper</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Media</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/contact">
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-3"></v-divider>

        <v-list-item link to="/form-fill">
          <v-list-item-icon>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Бүртгүүлэх</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item link to="/submissions">
          <v-list-item-content>
            <v-list-item-title>Бүртгэлүүд</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-divider class="my-3"></v-divider>

        <v-list-item>
          <v-list-item-content>
            <gradient-button variant="solid" size="medium" :full-width="true">
              Book Tickets
            </gradient-button>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import GradientButton from "./GradientButton.vue";

export default {
  name: "HeaderNav",
  components: {
    GradientButton,
  },
  data() {
    return {
      drawer: false,
    };
  },
};
</script>

<style scoped>
/* === NAVIGATION BAR === */
.top-navbar {
  z-index: 100 !important;
  padding: 0 40px !important;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.3) !important;
}

.top-navbar.v-app-bar--is-scrolled {
  background: rgba(0, 0, 0, 0.8) !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
}

.top-navbar .v-toolbar__content {
  padding: 4px 0;
}

/* Logo Section */
.logo-section {
  cursor: pointer;
}

.logo-section a {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 45px;
  width: auto;
  transition: transform 0.3s ease;
}

.logo-img:hover {
  transform: scale(1.05);
}

/* Date and Location */
.date-location {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.date-text {
  font-size: 13px;
  font-weight: 500;
  color: white;
  opacity: 0.95;
}

.location-text {
  font-size: 13px;
  font-weight: 400;
  color: white;
  opacity: 0.85;
}

/* Navigation Menu */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-btn {
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: none;
  color: white !important;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.nav-btn:hover {
  opacity: 1;
}

/* Book Tickets Button in Navbar */
.book-tickets-nav-btn {
  margin-left: 16px;
}

/* === RESPONSIVE DESIGN === */
@media (max-width: 1264px) {
  .top-navbar {
    padding: 0 24px !important;
  }
}

@media (max-width: 960px) {
  .nav-btn {
    font-size: 12px !important;
    padding: 0 8px !important;
  }

  .book-tickets-nav-btn {
    margin-left: 8px;
  }
}

@media (max-width: 600px) {
  .top-navbar {
    padding: 0 8px !important;
  }

  .logo-img {
    height: 32px;
  }

  .nav-btn {
    font-size: 10px !important;
    padding: 0 4px !important;
    min-width: auto !important;
  }

  .book-tickets-nav-btn {
    margin-left: 4px;
  }
}
</style>
